import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hooks/redux';
import { modalSlice } from '../../../../store/reducers/ModalSlice';
import { ModalVariants } from '../../../../models/Common';
import { IMultiAccount } from '../../../../models/UserInfo';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { ReactComponent as AccountLocationIcon } from '../../../../assets/images/multiAccount/locationIcon.svg';

interface ManageAccountProps {
  address: string;
  user?: IMultiAccount;
}

export const ManageAccount: FC<ManageAccountProps> = ({ address, user }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleClick = () => {
    dispatch(
      openModal({
        modalVariants: ModalVariants.SelectAccount,
        content: {
          accountId: user?.UserID,
        },
      }),
    );
  };

  return (
    <div className="service-card card card__extra card__account">
      <div className="service-card__account-manage">{t('multiAccount.managing')}</div>
      <div className="service-card__info-container">
        <div className="service-card__info-container__tariff">
          <div className="service-card__info-container__tariff__info card__account-info">
            <div className="service-card__info-container__tariff__info__header">
              <div className="service-card__info-container__tariff__info__header__icon">
                <div className="icon">
                  <AccountLocationIcon />
                </div>
              </div>
            </div>
            <div className="service-card__info-container__tariff__info-service">
              <div className="service-card__info-container__tariff__info-service__name">
                <div className="service-card__info-container__tariff__info-service__name__header">
                  <p className="card__account-address">{user?.Alias || address}</p>
                </div>
              </div>
              <p className="service-card__info-container__tariff__info-service__account-number">
                <span>{t('multiAccount.account')}</span> {user?.UserID}
              </p>
            </div>
            <div className="service-card__info-container__button select-account">
              <div className="service-card__info-container__button-price" />
              <TextButton
                label={t('buttons.selectAccount')}
                handleClick={handleClick}
                className={TextButtonClassNames.Filled}
                isArrow
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
